
import { useEffect } from "react";
import { motion } from "framer-motion";

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Terms & Conditions</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>
              <p>
                Please read these Terms and Conditions carefully before using our website. By accessing
                or using our website, you agree to be bound by these terms.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Acceptance of Terms</h2>
              <p>
                By accessing and using the Aarsa website, you accept and agree to be bound by the terms
                and provision of this agreement.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Use License</h2>
              <p>
                Permission is granted to temporarily download one copy of the materials on Aarsa's website
                for personal, non-commercial transitory viewing only.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Product Information</h2>
              <p>
                We strive to provide accurate product descriptions and images. However, we do not warrant
                that product descriptions or other content on this site is accurate, complete, reliable,
                current, or error-free.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Pricing</h2>
              <p>
                All prices are in Indian Rupees (INR) and are subject to change without notice. We reserve
                the right to modify prices at any time.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Payment</h2>
              <p>
                We accept various payment methods including credit/debit cards, UPI, and cash on delivery.
                All payments are processed securely through our payment partners.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Limitation of Liability</h2>
              <p>
                Aarsa shall not be liable for any indirect, incidental, special, consequential, or punitive
                damages resulting from your use of or inability to use the service.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Contact Information</h2>
              <p>
                For questions about these Terms & Conditions, please contact us at{" "}
                <a href="mailto:sales@myaarsa.com" className="text-aarsa-sage-600 hover:underline">
                  sales@myaarsa.com
                </a>
              </p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
